import _createForOfIteratorHelper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module font/fontcommand
 */
import { Command } from 'ckeditor5/src/core.js';
/**
 * The base font command.
 */
var FontCommand = /*#__PURE__*/function (_Command) {
  _inherits(FontCommand, _Command);
  var _super = _createSuper(FontCommand);
  /**
   * Creates an instance of the command.
   *
   * @param editor Editor instance.
   * @param attributeKey The name of a model attribute on which this command operates.
   */
  function FontCommand(editor, attributeKey) {
    var _this;
    _classCallCheck(this, FontCommand);
    _this = _super.call(this, editor);
    _this.attributeKey = attributeKey;
    return _this;
  }
  /**
   * @inheritDoc
   */
  _createClass(FontCommand, [{
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      this.value = doc.selection.getAttribute(this.attributeKey);
      this.isEnabled = model.schema.checkAttributeInSelection(doc.selection, this.attributeKey);
    }
    /**
     * Executes the command. Applies the `value` of the {@link #attributeKey} to the selection.
     * If no `value` is passed, it removes the attribute from the selection.
     *
     * @param options Options for the executed command.
     * @param options.value The value to apply.
     * @fires execute
     */
  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      var selection = document.selection;
      var value = options.value;
      var batch = options.batch;
      var updateAttribute = function updateAttribute(writer) {
        if (selection.isCollapsed) {
          if (value) {
            writer.setSelectionAttribute(_this2.attributeKey, value);
          } else {
            writer.removeSelectionAttribute(_this2.attributeKey);
          }
        } else {
          var ranges = model.schema.getValidRanges(selection.getRanges(), _this2.attributeKey);
          var _iterator = _createForOfIteratorHelper(ranges),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var range = _step.value;
              if (value) {
                writer.setAttribute(_this2.attributeKey, value, range);
              } else {
                writer.removeAttribute(_this2.attributeKey, range);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      };
      // In some scenarios, you may want to use a single undo step for multiple changes (e.g. in color picker).
      if (batch) {
        model.enqueueChange(batch, function (writer) {
          updateAttribute(writer);
        });
      } else {
        model.change(function (writer) {
          updateAttribute(writer);
        });
      }
    }
  }]);
  return FontCommand;
}(Command);
export { FontCommand as default };